module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ef-Gd.b15d5d9f.png";